import { render, staticRenderFns } from "./UserButtons.vue?vue&type=template&id=00321876"
import script from "./UserButtons.vue?vue&type=script&lang=ts"
export * from "./UserButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports